import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { TRACKING } from '../../../enums/trackingParts.enum';
import { TARIFF_CONTEXT } from '../../../enums/tariffContext.enum';
import { StorageService } from '../../../services/storage.service';

@Component({
    selector: 'bdo-contract-end-recent-home',
    templateUrl: './contract-end-recent-home.component.html',
    styleUrls: ['./contract-end-recent-home.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ContractEndRecentHomeComponent implements OnInit {
  public TRACKING = TRACKING;

  ngOnInit(): void {
    StorageService.setTariffContext(TARIFF_CONTEXT.END);
  }

}
